import {
  Button,
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerHeaderTitle,
  SelectTabData,
  SelectTabEvent,
  Tab,
  TabList,
} from "@fluentui/react-components";
import { FC, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import { togglePromptDrawer } from "../../store/slices/ClimateAssistantSlice";
import { Dismiss24Regular } from "@fluentui/react-icons";
import Typography from "../../components/Typography";
import { customTokens } from "../../theme/theme";
import {
  usePromptDrawerStyles,
  usePromptWindowStyles,
} from "./AIClimateAssistant.styles";

interface IMobilePromptDrawer {
  handleSend: (customQuery?: string, topicName?: string) => Promise<void>;
}

const MobilePromptDrawer: FC<IMobilePromptDrawer> = ({ handleSend }) => {
  const dispatch = useDispatch();
  const styles = usePromptDrawerStyles();
  const promptStyles = usePromptWindowStyles();

  const { promptList, openPromptDrawer } = useSelector(
    (state: RootState) => state.climateAssistant
  );

  const [selectedValue, setSelectedValue] = useState("all");

  const onTabSelect = (event: SelectTabEvent, data: SelectTabData) => {
    setSelectedValue(data.value as string);
  };

  const handlePromptClick = (prompt: string, heading: string) => {
    dispatch(togglePromptDrawer(false));
    handleSend(prompt, heading);
  };

  return (
    <>
      <Drawer
        open={openPromptDrawer}
        position="bottom"
        onOpenChange={(_, { open }) => dispatch(togglePromptDrawer(open))}
        size="medium"
        className={styles.drawerContainer}
      >
        <DrawerHeader className={styles.drawerHeader}>
          <DrawerHeaderTitle
            action={
              <Button
                appearance="subtle"
                aria-label="Close"
                icon={<Dismiss24Regular />}
                onClick={() => dispatch(togglePromptDrawer(false))}
              />
            }
          >
            <Typography variant="body1" color={customTokens.fontDarkGrayBody}>
              View prompts
            </Typography>
          </DrawerHeaderTitle>
        </DrawerHeader>

        <DrawerBody>
          <TabList
            selectedValue={selectedValue}
            onTabSelect={onTabSelect}
            className={styles.tabList}
          >
            <Tab id="all" value="all">
              All
            </Tab>

            <Tab id="ftcSupport" value="ftcSupport">
              FTC Support
            </Tab>
          </TabList>

          <div className={styles.tabPanel}>
            <div className={promptStyles.promptContainer}>
              {promptList.map((item) => {
                return (
                  <div
                    key={item.id}
                    className={promptStyles.promptBox}
                    onClick={() => handlePromptClick(item.prompt, item.heading)}
                  >
                    {item.tags.map((tag) => {
                      return (
                        <div
                          className={promptStyles.tagWrapper}
                          key={tag.tagName}
                        >
                          <div
                            className={promptStyles.tag}
                            style={{ backgroundColor: tag.backgroundColor }}
                          >
                            <Typography
                              variant="caption1"
                              tabletVariant="caption2"
                              color={tag.color}
                            >
                              {tag.tagName}
                            </Typography>
                          </div>
                        </div>
                      );
                    })}

                    <Typography
                      variant="bodyMRegular"
                      tabletVariant="body1"
                      color={customTokens.colorNeutralForeground2}
                    >
                      {item.heading}
                    </Typography>

                    <Typography
                      variant="body1"
                      tabletVariant="bodyXSRegular"
                      color={customTokens.colorNeutralForeground4}
                    >
                      {item.prompt}
                    </Typography>
                  </div>
                );
              })}
            </div>
          </div>
        </DrawerBody>
      </Drawer>
    </>
  );
};

export default MobilePromptDrawer;
